export enum oreV2Type{
    normal,
    special
}

export enum oreV2OccupyType{
    small,
    big
}

export interface oreV2Interface{
    //ID
    id:number,
    //名字
    name:string,
    //矿产类型
    type:number,
    //价格
    price:number,
    //物品数量区间
    objCount:number[],
    //可以开出的物品
    hasObj:oreAriseObj[]
}

export interface oreAriseObj{
    //ID
    id:number,
    //权重
    weight:number
}

export interface oreV2ObjInterface{
    //ID
    id:number,
    //名字
    name:string,
    //类型
    type:number,
    //占用空间
    occupyType:oreV2OccupyType,
    //展示的图片
    showSp:string,
    //描述
    explain:string,
    //出售的价格
    sellPrice:number,
    //绑定的背包物品
    bindBackpackId:number
}

export interface oreV2Map{
    [id:number]:oreV2Interface;
}

export interface oreV2ObjMap{
    [id:number]:oreV2ObjInterface
}

export interface oreV2SaveData{
    oreV2s:number[],
    oreV2Type:oreV2Type,
    orePosAry:cc.Vec2[]
}

let oreV2Ary:oreV2Interface[] = null;

export function getOreV2Ary(){
    if(!oreV2Ary){
        oreV2Ary = [
            {id:0,name:"矿山",type:0,objCount:[2,3],price:5000,hasObj:
                [
                    {id:1004,weight:1000},
                    {id:1001,weight:2000},
                    {id:1000,weight:1000},
                    {id:1033,weight:2000},
                    {id:1013,weight:1000},
                    {id:1002,weight:1000},
                    {id:1027,weight:1000},
                    {id:1006,weight:1000}
                ]
            },
            {id:1,name:"浪浪山",type:0,objCount:[2,3],price:10000,hasObj:
                [
                    {id:1008,weight:2000},
                    {id:1009,weight:10},
                    {id:1001,weight:2990},
                    {id:1010,weight:1990},
                    {id:1013,weight:2000},
                    {id:1004,weight:500},
                    {id:1011,weight:500},
                    {id:1012,weight:10}
                ]
            },
            {id:2,name:"花果山",type:0,objCount:[2,3],price:20000,hasObj:
                [
                    {id:1007,weight:2000},
                    {id:1033,weight:1990},
                    {id:1027,weight:10},
                    {id:1001,weight:1000},
                    {id:1014,weight:1000},
                    {id:1002,weight:1000},
                    {id:1010,weight:1500},
                    {id:1011,weight:1500}
                ]
            },
            {id:3,name:"兵马俑古矿",type:1,objCount:[3,4],price:30000,hasObj:
                [
                    {id:1015,weight:1500},
                    {id:1005,weight:10},
                    {id:1016,weight:990},
                    {id:1007,weight:1500},
                    {id:1017,weight:1000},
                    {id:1003,weight:2000},
                    {id:1018,weight:1500},
                    {id:1019,weight:1500}
                ]
            },
            {id:4,name:"法老古矿",type:1,objCount:[4,5],price:58888,hasObj:
                [
                    {id:1005,weight:2000},
                    {id:1016,weight:500},
                    {id:1020,weight:1500},
                    {id:1022,weight:2000},
                    {id:1003,weight:1500},
                    {id:1023,weight:2000},
                    {id:1024,weight:5000}
                ]
            },
            {id:5,name:"远古遗矿",type:2,objCount:[5,7],price:100000,hasObj:
                [
                    {id:1025,weight:10},
                    {id:1026,weight:2000},
                    {id:1027,weight:1900},
                    {id:1028,weight:20},
                    {id:1012,weight:980},
                    {id:1003,weight:2500},
                    {id:1029,weight:100},
                    {id:1015,weight:2500},
                    {id:1032,weight:10},
                    {id:1030,weight:10},
                    {id:1031,weight:10}
                ]
            },
        ]
    }
    return oreV2Ary;
}

let oreV2Map:oreV2Map = null;

export function getOreV2Map(){
    if(!oreV2Map){
        oreV2Map = <oreV2Map>{};
        let ary = getOreV2Ary();
        for(let k of ary){
            oreV2Map[k.id] = k;
        }
    }
    return oreV2Map;
}

let specialAry:oreV2Interface[] = null;

export function getOreV2SpecialAry(){
    if(!specialAry){
        specialAry = [
            {id:0,name:"矿山",type:0,objCount:[2,3],price:50000,hasObj:
                [
                    {id:1004,weight:1000},
                    {id:1001,weight:2000},
                    {id:1000,weight:1000},
                    {id:1033,weight:2000},
                    {id:1013,weight:1000},
                    {id:1002,weight:1000},
                    {id:1027,weight:1000},
                    {id:1006,weight:1000}
                ]
            },
            {id:1,name:"浪浪山",type:0,objCount:[2,3],price:100000,hasObj:
                [
                    {id:1008,weight:2000},
                    {id:1009,weight:10},
                    {id:1001,weight:2990},
                    {id:1010,weight:1990},
                    {id:1013,weight:2000},
                    {id:1004,weight:500},
                    {id:1011,weight:500},
                    {id:1012,weight:10}
                ]
            },
            {id:2,name:"花果山",type:0,objCount:[2,3],price:200000,hasObj:
                [
                    {id:1007,weight:2000},
                    {id:1033,weight:1990},
                    {id:1027,weight:10},
                    {id:1001,weight:1000},
                    {id:1014,weight:1000},
                    {id:1002,weight:1000},
                    {id:1010,weight:1500},
                    {id:1011,weight:1500}
                ]
            },
            {id:3,name:"兵马俑古矿",type:1,objCount:[3,4],price:300000,hasObj:
                [
                    {id:1015,weight:1500},
                    {id:1005,weight:10},
                    {id:1016,weight:990},
                    {id:1007,weight:1500},
                    {id:1017,weight:1000},
                    {id:1003,weight:2000},
                    {id:1018,weight:1500},
                    {id:1019,weight:1500}
                ]
            },
            {id:4,name:"法老古矿",type:1,objCount:[4,5],price:58888,hasObj:
                [
                    {id:1005,weight:2000},
                    {id:1016,weight:500},
                    {id:1020,weight:1500},
                    {id:1022,weight:2000},
                    {id:1003,weight:1500},
                    {id:1023,weight:2000},
                    {id:1024,weight:5000}
                ]
            },
            {id:5,name:"远古遗矿",type:2,objCount:[5,7],price:100000,hasObj:
                [
                    {id:1025,weight:10},
                    {id:1026,weight:2000},
                    {id:1027,weight:1900},
                    {id:1028,weight:20},
                    {id:1012,weight:980},
                    {id:1003,weight:2500},
                    {id:1029,weight:100},
                    {id:1015,weight:2500},
                    {id:1032,weight:10},
                    {id:1030,weight:10},
                    {id:1031,weight:10}
                ]
            },
        ];
    }
    return specialAry;
}

let speciaMap:oreV2Map = null;

export function getOreV2SpecialMap(){
    if(!speciaMap){
        speciaMap = <oreV2Map>{};
        let ary = getOreV2SpecialAry();
        for(let k of ary){
            speciaMap[k.id] = k;
        }
    }
    return speciaMap;
}

let oreV2ObjAry:oreV2ObjInterface[] = null;

export function getOreV2ObjAry(){
    if(!oreV2ObjAry){
        oreV2ObjAry = [
            {id:1000  ,name:"土鸡蛋",showSp:"普通鸡蛋",type:0,occupyType:oreV2OccupyType.small,explain:"平平无奇的土鸡蛋，但很具有营养价值，很受大家欢迎。尤其是村口大妈",sellPrice:50,bindBackpackId:21001},
            {id:1001  ,name:"奥里给",showSp:"奥里给",type:0,occupyType:oreV2OccupyType.small,explain:"居然有依托大便",sellPrice:80,bindBackpackId:21110},
            {id:1002  ,name:"水草",showSp:"水草",type:0,occupyType:oreV2OccupyType.small,explain:"为什么矿地有水草？",sellPrice:5,bindBackpackId:10376},
            {id:1003  ,name:"青眼白龙",showSp:"青眼白龙",type:0,occupyType:oreV2OccupyType.small,explain:"货真价实的青眼白龙！",sellPrice:9999,bindBackpackId:21109},
            {id:1004  ,name:"花岗岩",showSp:"花岗岩",type:0,occupyType:oreV2OccupyType.small,explain:"普通的一块花岗岩",sellPrice:500,bindBackpackId:11100},
            {id:1005  ,name:"木乃伊",showSp:"木乃伊",type:0,occupyType:oreV2OccupyType.big,explain:"相传是古埃及法老级别的人物",sellPrice:10000,bindBackpackId:21108},
            {id:1006  ,name:"河蚌",showSp:"河蚌",type:0,occupyType:oreV2OccupyType.small,explain:"纹路粗糙，平平无奇的河蚌。",sellPrice:100,bindBackpackId:10300},
            {id:1007  ,name:"翡翠矿",showSp:"翡翠矿",type:0,occupyType:oreV2OccupyType.small,explain:"可以开出翡翠原石的翡翠矿",sellPrice:1500,bindBackpackId:11102},
            {id:1008  ,name:"沉积岩",showSp:"沉积岩",type:0,occupyType:oreV2OccupyType.small,explain:"成层堆积的松散沉积物固结而成的岩石，有可能开出恐龙化石！",sellPrice:1000,bindBackpackId:11101},
            {id:1009  ,name:"白色珍珠",showSp:"白珍珠",type:0,occupyType:oreV2OccupyType.small,explain:"表面光滑细腻，散发出来的光泽让人眼前一亮",sellPrice:2000,bindBackpackId:10370},
            {id:1010 ,name:"银蛋",showSp:"银色鸡蛋",type:0,occupyType:oreV2OccupyType.small,explain:"银蛋，根本咬不动，无法孵化。",sellPrice:200,bindBackpackId:21002},
            {id:1011 ,name:"白纹蚌",showSp:"白纹蚌",type:0,occupyType:oreV2OccupyType.small,explain:"白色的纹路，看起来可能会开出一些好东西哦。",sellPrice:800,bindBackpackId:10303},
            {id:1012 ,name:"金色珍珠",showSp:"金珍珠",type:0,occupyType:oreV2OccupyType.small,explain:"完美无瑕的金色珍珠，珍贵的帝王之选",sellPrice:30000,bindBackpackId:10374},
            {id:1013 ,name:"渔网衣",showSp:"渔网衣",type:0,occupyType:oreV2OccupyType.small,explain:"纪梵西新品渔网衣，让你穿上和没穿一样！",sellPrice:599,bindBackpackId:21107},
            {id:1014 ,name:"金蛋",showSp:"金鸡蛋",type:0,occupyType:oreV2OccupyType.small,explain:"24K纯金外壳的鸡蛋",sellPrice:500,bindBackpackId:21003},
            {id:1015 ,name:"远古龙蛋",showSp:"恐鸟蛋",type:0,occupyType:oreV2OccupyType.small,explain:"来自远古的留下的遗物，不知道能孵化出什么神奇的生物？",sellPrice:2000,bindBackpackId:21004},
            {id:1016 ,name:"水晶矿",showSp:"水晶矿",type:0,occupyType:oreV2OccupyType.small,explain:"数千年才能形成的珍稀矿石",sellPrice:40000,bindBackpackId:11113},
            {id:1017 ,name:"火山石",showSp:"火山石",type:0,occupyType:oreV2OccupyType.small,explain:"火山喷发时形成的矿石哦",sellPrice:6000,bindBackpackId:11106},
            {id:1018 ,name:"木棺",showSp:"精品骨灰盒",type:0,occupyType:oreV2OccupyType.big,explain:"尘封几千年的棺椁，每口里面都有价值连城的宝贝",sellPrice:19999,bindBackpackId:21106},
            {id:1019 ,name:"瓷娃娃",showSp:"瓷娃娃",type:0,occupyType:oreV2OccupyType.small,explain:"外壳仿佛是瓷制的，敲起来的声音非常好听。",sellPrice:3000,bindBackpackId:10307},
            {id:1020 ,name:"流纹大理石",showSp:"流纹大理石",type:0,occupyType:oreV2OccupyType.small,explain:"外表其貌不扬，实际重量超出想象",sellPrice:10000,bindBackpackId:11108},
            {id:1022 ,name:"砂质原石",showSp:"砂质原石",type:0,occupyType:oreV2OccupyType.small,explain:"表面摸起来很粗糙，砂质的岩石。",sellPrice:20000,bindBackpackId:11111},
            {id:1023 ,name:"云纹矿",showSp:"云纹矿",type:0,occupyType:oreV2OccupyType.small,explain:"一道一道的流云纹路，懂行的都会买下这个石头。",sellPrice:30000,bindBackpackId:11112},
            {id:1024 ,name:"珍宝贝壳",showSp:"珍宝贝壳",type:0,occupyType:oreV2OccupyType.small,explain:"外表其貌不扬，其中蕴涵千年珍宝！",sellPrice:70000,bindBackpackId:10308},
            {id:1025 ,name:"远古神兽化石",showSp:"远古神兽化石",type:0,occupyType:oreV2OccupyType.big,explain:"拥有一个便富可敌国，凑齐全部化石即可获得神秘奖励",sellPrice:100000,bindBackpackId:21105},
            {id:1026 ,name:"彩虚琨",showSp:"彩虚琨",type:0,occupyType:oreV2OccupyType.small,explain:"黄昏见证虔诚的信徒，巅峰诞生虚伪的拥护",sellPrice:60000,bindBackpackId:11114},
            {id:1027 ,name:"鱼骨头",showSp:"鱼骨头",type:0,occupyType:oreV2OccupyType.small,explain:"不清楚是古代的鱼还是现代的鱼",sellPrice:30000,bindBackpackId:10382},
            {id:1028 ,name:"超大黄金奥里给",showSp:"超大黄金奥里给",type:0,occupyType:oreV2OccupyType.big,explain:"来自黄金古国的镇国之宝，只存在于传说里！",sellPrice:99999,bindBackpackId:21104},
            {id:1029 ,name:"深渊传说",showSp:"深渊传说",type:0,occupyType:oreV2OccupyType.small,explain:"深渊传说海蚌，生活在海沟的最深处！",sellPrice:50000,bindBackpackId:10313},
            {id:1030 ,name:"牛骨架",showSp:"牛骨架",type:0,occupyType:oreV2OccupyType.big,explain:"拥有一个便富可敌国，凑齐全部化石即可获得神秘奖励",sellPrice:100000,bindBackpackId:21103},
            {id:1031 ,name:"蛇骨架",showSp:"蛇骨架",type:0,occupyType:oreV2OccupyType.big,explain:"拥有一个便富可敌国，凑齐全部化石即可获得神秘奖励",sellPrice:100000,bindBackpackId:21102},
            {id:1032 ,name:"鸡骨架",showSp:"鸡骨架",type:0,occupyType:oreV2OccupyType.big,explain:"拥有一个便富可敌国，凑齐全部化石即可获得神秘奖励",sellPrice:100000,bindBackpackId:21101},
            {id:1033 ,name:"JK制服",showSp:"JK制服",type:0,occupyType:oreV2OccupyType.big,explain:"看外貌和材质，好像是妈妈穿的jk！",sellPrice:168,bindBackpackId:21100}
            
        ]
    }
    return oreV2ObjAry;
}

let oreV2ObjMap:oreV2ObjMap = null;

export function getOreV2ObjMap(){
    if(!oreV2ObjMap){
        let ary = getOreV2ObjAry();
        oreV2ObjMap = <oreV2ObjMap>{};
        for(let k of ary){
            oreV2ObjMap[k.id] = k;
        }
    }
    return oreV2ObjMap;
}

export let refrenshItemTypeAry:number[][] = [
    [0,0,0,0,0,0],
    [0,0,0,1,1,2],
    [1,1,1,1,1,1],
    [1,1,1,1],
    [2,2,2]
]

export let refrenshItemPosAry:cc.Vec2[][] = [
    [
        cc.v2(-250,180),
        cc.v2(0,180),
        cc.v2(250,180),
        cc.v2(-150,-100),
        cc.v2(150,-100),
        cc.v2(0,-360)
    ],
    [
        cc.v2(-250,180),
        cc.v2(0,180),
        cc.v2(250,180),
        cc.v2(-200,-75),
        cc.v2(200,-75),
        cc.v2(0,-330)
    ],
    [
        cc.v2(-200,200),
        cc.v2(200,200),
        cc.v2(-200,-75),
        cc.v2(200,-75),
        cc.v2(-200,-350),
        cc.v2(200,-350)
    ],
    [
        cc.v2(-200,200),
        cc.v2(200,200),
        cc.v2(-200,-250),
        cc.v2(200,-250)
    ],
    [
        cc.v2(0,300),
        cc.v2(0,-50),
        cc.v2(0,-400)
    ]
]
